import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import { setNotification } from '../../components/ui-widgets/uiWidgetsSlice'
import { useAppDispatch } from '../../../app/hooks'
import { RtkQueryHelper } from '../../../api-services/shared/RtkQueryHelper'
import { type AssetHolderUpdateDto } from '../../../api-schema-types/asset-holdings/AssetHolderCrudDtos'
import SummarizeIcon from '@mui/icons-material/Summarize'
import { useGetActivityStatementSignedUrl } from '../../../api-services/asset-holdings/activityStatementApi'
import {
  DATE_FORMAT_API,
  formatDateAsApiFormat,
  formatDateStringAsApiFormat
} from '../../../utility/formatters/DateFormatter'
import { openInNewTab } from '../../../utility/dom/DomWindowHelpers'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import TextField, { type TextFieldProps } from '@mui/material/TextField'
import { sub } from 'date-fns'

interface ActivityStatementComponentProps {
  assetHolder: AssetHolderUpdateDto
}

interface ActivityStatementSignedUrl {
  signedUrl: string
}

const ActivityStatementComponent = (props: ActivityStatementComponentProps): JSX.Element => {
  const dispatch = useAppDispatch()
  const { assetHolder } = props

  const [apiActivityStatementTrigger] = useGetActivityStatementSignedUrl()
  const [startDate, setStartDate] = useState<string | null>(formatDateAsApiFormat(sub(new Date(), { months: 2 })))
  const [endDate, setEndDate] = useState<string | null>(formatDateAsApiFormat(new Date()))
  const [signedUrl, setSignedUrl] = useState<string | null>(null)

  const handleViewStatement = (): void => {
    apiActivityStatementTrigger({
      assetHolderId: assetHolder.assetHolderId,
      startDate: formatDateStringAsApiFormat(startDate),
      endDate: formatDateStringAsApiFormat(endDate)
    })
      .unwrap()
      .then((triggerResult) => {
        const url = (triggerResult as ActivityStatementSignedUrl).signedUrl
        setSignedUrl(url)
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  useEffect(() => {
    if (signedUrl !== null) {
      openInNewTab(signedUrl)
    }
  }, [signedUrl])

  return (
    <React.Fragment>
      <Grid item md={6}>
        <Box>
          <h3 className='nk-block-title page-title'>Customer Activity Statement</h3>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                      inputFormat={DATE_FORMAT_API}
                      disableMaskedInput={true}
                      renderInput={(props: JSX.IntrinsicAttributes & TextFieldProps) => <TextField {...props} className={'w-100'} />}
                      label="Start date"
                      value={startDate}
                      onChange={(newValue: any) => {
                        setStartDate(newValue)
                      }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item md={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                      inputFormat={DATE_FORMAT_API}
                      disableMaskedInput={true}
                      renderInput={(props: JSX.IntrinsicAttributes & TextFieldProps) => <TextField {...props} className={'w-100'} />}
                      label="End date"
                      value={endDate}
                      onChange={(newValue: any) => {
                        setEndDate(newValue)
                      }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item lg={12}>
                <Button startIcon={<SummarizeIcon/>} variant={'outlined'} onClick={handleViewStatement} sx={{ mr: 3 }}>
                  View Member Statement
                </Button>
              </Grid>
            </Grid>
        </Box>
      </Grid>
    </React.Fragment>
  )
}

export default ActivityStatementComponent
